import { useMutation, useQuery } from "@tanstack/react-query";

import { useMe } from "../../../hooks/queries";
import { LabelData } from "../../../models/LabelData";
import DataSvc from "../../../services/dataSvc";

const useLabels = (params: any, fetchWithoutBlock = false) => {
  const { data: me } = useMe();

  const query = useQuery(
    ["labels", params],
    () => {
      if (!params.organization_id) {
        return [];
      } else {
        return DataSvc.getLabels(params, fetchWithoutBlock);
      }
    },
    {
      enabled: !!me
    }
  );

  const createLabelMutation = useMutation((label: any) => {
    return DataSvc.createLabel(label);
  });

  const deleteLabelMutation = useMutation((labelId: number) => {
    return DataSvc.deleteLabel(labelId);
  });

  const updateLabelMutation = useMutation((label: LabelData) => {
    return DataSvc.updateLabel(label.id, label.name);
  });

  const deleteLabel = async (labelId: number) => {
    await deleteLabelMutation.mutateAsync(labelId);
    query.refetch();
  };

  const updateLabel = async (label: LabelData) => {
    await updateLabelMutation.mutateAsync(label);
    query.refetch();
  };

  const createLabel = async (label: any) => {
    await createLabelMutation.mutateAsync(label);
    query.refetch();
  };

  return {
    createLabel,
    deleteLabel,
    updateLabel,
    ...query
  };
};

export default useLabels;
